<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav mat-elevation-z2"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <!-- Here is the sidenav -->
    <admin-sidenav />
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="admin-topbar">
      <button
        mat-icon-button
        (click)="drawer.toggle()"
        class="user-sidebar-toggle"
      >
        <mat-icon svgIcon="menu" />
      </button>
    </div>
    <div id="admin-panel-container">
      <div class="container my-3">
        <ng-content />
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
